module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.info) ? _c('el-dialog', {
    attrs: {
      "title": "我要购买账号",
      "visible": _vm.gmFormVisible,
      "custom-class": "dialog-t",
      "width": "890px",
      "before-close": _vm.clearDl
    },
    on: {
      "update:visible": function($event) {
        _vm.gmFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "form"
  }, [(_vm.configQW && _vm.configQW.display_weixin_buy == 1) ? _c('div', {
    staticClass: "input_text lef"
  }, [_c('span', {
    staticClass: "label lar"
  }, [_vm._v("请添加购买专员")]), _vm._v(" "), _c('span', {
    staticClass: "static"
  }, [_vm._v(_vm._s(_vm.configQW.service_buy))])]) : _vm._e(), _vm._v(" "), (_vm.configQW && _vm.configQW.display_qq_buy == 1) ? _c('div', {
    staticClass: "input_text lef"
  }, [_c('span', {
    staticClass: "label lar"
  }, [_vm._v("请添加购买专员")]), _vm._v(" "), _c('span', {
    staticClass: "static"
  }, [_vm._v(_vm._s(_vm.configQW.qq_buy))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input_text lef"
  }, [_c('span', {
    staticClass: "label lar"
  }, [_vm._v("账号ID")]), _vm._v(" "), _c('span', {
    staticClass: "static"
  }, [_vm._v(_vm._s(_vm.userInfo.username))])]), _vm._v(" "), _c('div', {
    staticClass: "input_text lef"
  }, [_c('span', {
    staticClass: "label lar"
  }, [_vm._v("您想购买的账号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.account),
      expression: "info.account"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.info.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "account", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input_text lef"
  }, [_c('span', {
    staticClass: "label lar"
  }, [_vm._v("卖方一口价")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sale_price),
      expression: "sale_price"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.sale_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sale_price = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input_text lef"
  }, [_c('span', {
    staticClass: "label lar"
  }, [_vm._v("您的最高报价")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.buy_price),
      expression: "form.buy_price"
    }],
    staticClass: "text",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.form.buy_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "buy_price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input_text lef"
  }, [_c('span', {
    staticClass: "label lar"
  }, [_vm._v("其他")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.others),
      expression: "form.others"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.form.others)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "others", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitBuy
    }
  }, [_vm._v("确认提交")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7c68bb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buyDialog/buyDialog.vue
// module id = 644
// module chunks = 31